import { __makeTemplateObject, __spreadArray, __assign } from '../../node_modules/tslib/tslib.es6.js';
import { themeGet, Text, Box } from '@primer/react';
import React, { useState, useEffect } from 'react';
import LTAnchoredOverlay from '../LTAnchoredOverlay/index.js';
import LTButton from '../LTButton/index.js';
import LTCheckbox from '../LTCheckbox/index.js';
import { LTTextInput } from '../LTInputBox/index.js';
import LTLoader from '../LTLoader/index.js';
import CheckBoxGroup from '../LTCheckboxGroup/index.js';
import styled from 'styled-components';
import { FUNCTION_TYPE } from '../../utils/constants.js';
import { createUniqueID } from '../../utils/functions.js';
import LTText from '../LTText/index.js';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var SelectPanelLoadingWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n"], ["\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  align-items: center;\n  padding: ", ";\n"])), themeGet("space.3"));
var OverlayContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 520px;\n"], ["\n  width: 520px;\n"])));
var ActionButtonGroup = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-items: center;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: end;\n  padding: ", ";\n  gap: ", ";\n"], ["\n  align-items: center;\n  border-top: 1px solid ", ";\n  display: flex;\n  justify-content: end;\n  padding: ", ";\n  gap: ", ";\n"])), themeGet("colors.border.lightGray"), themeGet("space.2"), themeGet("space.2"));
var SelectPanelHeader = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding: ", " 14px ", " 14px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  gap: ", ";\n  padding: ", " 14px ", " 14px;\n"])), themeGet("space.1"), themeGet("space.3"), themeGet("space.3"));
var SelectAllButtonWrapper = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background-color: ", ";\n  padding: ", " ", ";\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"], ["\n  background-color: ", ";\n  padding: ", " ", ";\n  border-top: 1px solid ", ";\n  border-bottom: 1px solid ", ";\n"])), themeGet("colors.bg.muted"), themeGet("space.2"), themeGet("space.3"), themeGet("colors.border.lightGray"), themeGet("colors.border.lightGray"));
var LTSelectPanel = function LTSelectPanel(_a) {
  var _React$createElement;
  var _b = _a.ariaLabel,
    ariaLabel = _b === void 0 ? undefined : _b,
    _c = _a.buttonClassName,
    buttonClassName = _c === void 0 ? '' : _c,
    _d = _a.customButtonClassName,
    customButtonClassName = _d === void 0 ? "" : _d,
    _e = _a.cancelButtonText,
    cancelButtonText = _e === void 0 ? "Reset" : _e,
    _f = _a.customHandlerButtonText,
    customHandlerButtonText = _f === void 0 ? "Add New Extension" : _f,
    _g = _a.customHandlerFunc,
    customHandlerFunc = _g === void 0 ? null : _g,
    _h = _a.customPanelButtonSize,
    customPanelButtonSize = _h === void 0 ? LTButton.Size.MEDIUM : _h,
    _j = _a.defaultValues,
    defaultValues = _j === void 0 ? [] : _j,
    _k = _a.label,
    label = _k === void 0 ? "" : _k,
    _l = _a.loading,
    loading = _l === void 0 ? false : _l,
    _m = _a.name,
    name = _m === void 0 ? "" : _m,
    _o = _a.options,
    options = _o === void 0 ? [] : _o,
    //[{ id, label, value }]
    _p = _a.onApply,
    //[{ id, label, value }]
    onApply = _p === void 0 ? function () {} : _p,
    _q = _a.subtitle,
    subtitle = _q === void 0 ? "" : _q,
    tabIndex = _a.tabIndex,
    _r = _a.title,
    title = _r === void 0 ? "" : _r;
  var _s = useState(false),
    closeOverlay = _s[0],
    setCloseOverlay = _s[1];
  var _t = useState(""),
    searchedText = _t[0],
    setSearchedText = _t[1];
  var _u = useState([]),
    selectedOptions = _u[0],
    setSelectedOptions = _u[1];
  var _v = useState(__spreadArray([], options, true)),
    searchedOption = _v[0],
    setSearchedOption = _v[1];
  useEffect(function () {
    return function () {
      setCloseOverlay(false);
    };
  });
  useEffect(function () {
    setSelectedOptions(defaultValues || []);
  }, []);
  useEffect(function () {
    setSearchedOption(options);
    if (defaultValues.length === 0) {
      setSelectedOptions([]);
    }
  }, [options]);
  useEffect(function () {
    if (!searchedText) {
      setSearchedOption(options);
      return;
    }
    var filteredOptions = options === null || options === void 0 ? void 0 : options.filter(function (_a) {
      var _b;
      var label = _a.label;
      return (_b = label === null || label === void 0 ? void 0 : label.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(searchedText.toLowerCase());
    });
    setSearchedOption(filteredOptions);
  }, [searchedText]);
  var handleSearchInputChange = function handleSearchInputChange(value) {
    setSearchedText(value);
  };
  var isApplyActive = function isApplyActive() {
    // Check if the arrays have the same length
    if (selectedOptions.length !== defaultValues.length) {
      return true;
    }
    // Convert all elements to strings to handle mixed types
    var sortedSelectedOptions = selectedOptions.map(String).sort();
    var sortedDefaultValues = defaultValues.map(String).sort();
    // Compare the sorted arrays
    for (var i = 0; i < sortedSelectedOptions.length; i++) {
      if (sortedSelectedOptions[i] !== sortedDefaultValues[i]) {
        return true;
      }
    }
    return false;
  };
  var handleSelectAllOptions = function handleSelectAllOptions() {
    if (selectedOptions.length !== options.length) {
      var allValues = searchedOption.map(function (element) {
        return element.value;
      });
      setSelectedOptions(allValues);
    } else {
      setSelectedOptions([]);
    }
  };
  var removeselectedOptions = function removeselectedOptions() {
    setSelectedOptions([]);
  };
  var onChange = function onChange(options) {
    setSelectedOptions(options);
  };
  var renderElement = function renderElement(element) {
    var name = element.name,
      value = element.value;
    return __assign({
      label: name,
      value: value === null || value === void 0 ? void 0 : value.toString(),
      checked: selectedOptions.includes(value.toString())
    }, element);
  };
  var clearSelectPanelData = function clearSelectPanelData() {
    setSelectedOptions([]);
    setSearchedText("");
    onApply([]);
  };
  var anchorId = createUniqueID("lt-anchor");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LTAnchoredOverlay, {
    ariaLabel: ariaLabel,
    anchorId: anchorId,
    anchorType: LTAnchoredOverlay.AnchorType.BUTTON,
    align: LTAnchoredOverlay.Align.START,
    buttonClassName: buttonClassName,
    customPanelButtonSize: customPanelButtonSize,
    customStyle: customButtonClassName,
    closeOverlay: closeOverlay,
    onBackdropClick: function onBackdropClick() {
      return setSelectedOptions(defaultValues);
    },
    side: LTAnchoredOverlay.Side.OUTSIDE_BOTTOM,
    title: title,
    tabIndex: tabIndex
  }, /*#__PURE__*/React.createElement(OverlayContainer, {
    id: anchorId
  }, /*#__PURE__*/React.createElement(SelectPanelHeader, null, /*#__PURE__*/React.createElement(LTText, {
    as: "h1",
    style: {
      fontWeight: "700",
      lineHeight: "20px",
      margin: 0
    },
    variant: LTText.TextVariant.HEADER_BOLD
  }, title), /*#__PURE__*/React.createElement(Text, null, subtitle), /*#__PURE__*/React.createElement(LTTextInput, {
    placeholder: "Search ".concat(name),
    onChange: handleSearchInputChange,
    value: searchedText,
    trailingAction: function trailingAction() {
      return handleSearchInputChange("");
    }
  })), loading ? /*#__PURE__*/React.createElement(SelectPanelLoadingWrapper, null, /*#__PURE__*/React.createElement(LTLoader, {
    description: "Fetching ".concat(name),
    size: LTLoader.SpinnerSizes.MEDIUM
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SelectAllButtonWrapper, null, searchedOption.length === 0 ? "No options available" : selectedOptions.length > 0 ? /*#__PURE__*/React.createElement(LTCheckbox, {
    indeterminate: selectedOptions.length > 0 && selectedOptions.length !== options.length,
    onChange: function onChange() {
      return removeselectedOptions();
    },
    checked: options.length === selectedOptions.length,
    label: "".concat(selectedOptions.length, " Selected")
  }) : /*#__PURE__*/React.createElement(LTCheckbox, {
    label: "Select All",
    checked: options.length === selectedOptions.length,
    onChange: function onChange() {
      return handleSelectAllOptions();
    }
  })), /*#__PURE__*/React.createElement(Box, {
    sx: {
      maxHeight: "200px",
      overflow: "scroll",
      padding: "14px 16px"
    }
  }, /*#__PURE__*/React.createElement(CheckBoxGroup, (_React$createElement = {
    visuallyHidden: true,
    defaultSelected: selectedOptions,
    label: label,
    options: searchedOption === null || searchedOption === void 0 ? void 0 : searchedOption.map(function (element) {
      return renderElement(element);
    })
  }, _defineProperty(_React$createElement, "visuallyHidden", true), _defineProperty(_React$createElement, "onChange", onChange), _React$createElement))), /*#__PURE__*/React.createElement(ActionButtonGroup, null, customHandlerFunc && _typeof(customHandlerFunc) === FUNCTION_TYPE && /*#__PURE__*/React.createElement(LTButton, {
    variant: LTButton.Variant.DEFAULT,
    onClick: function onClick() {
      setCloseOverlay(true);
      customHandlerFunc();
    },
    style: {
      marginRight: "auto"
    }
  }, customHandlerButtonText), /*#__PURE__*/React.createElement(LTButton, {
    variant: LTButton.Variant.DEFAULT,
    onClick: function onClick() {
      setCloseOverlay(true);
      clearSelectPanelData();
    },
    disabled: selectedOptions.length === 0
  }, cancelButtonText), /*#__PURE__*/React.createElement(LTButton, {
    variant: LTButton.Variant.PRIMARY,
    onClick: function onClick() {
      onApply(selectedOptions);
      setCloseOverlay(true);
    },
    disabled: !isApplyActive()
  }, "Apply"))))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { LTSelectPanel as default };
